<template>
  <div class="chart-card">
    <loading v-if="isLoading" />
    <div class="chart-header">
      <h2>📊 Taxas de Aprovação/reprovação</h2>
    </div>

    <div class="controls">
      <v-select class="year-select" :items="anoLectivoAll" v-model="anoLectivoSelected" @change="carregarDados()"
        item-value="descricao" item-text="novadescricao" label="Ano letivo" outlined dense hide-details></v-select>
      <v-select class="year-select" v-if="imsFiltrados.length" :items="imsFiltrados" v-model="imsAssociadoSelect"
        @change="filtrarIMS()" item-value="descricao" item-text="descricaoFilhacao" label="Colégios" outlined dense
        hide-details></v-select>
    </div>

    <div class="chart-container">
      <bar-chart v-if="chartData" :chart-data="chartData" :options="chartOptions" />
      <div v-else class="no-data">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 17V11M15 17V13M3 21H21M5 21V7H19V21M9 3H15V7H9V3Z" stroke="#E5E7EB" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <p>Nenhum dado disponível</p>
      </div>
    </div>

    <div class="chart-footer">
      <div class="legend-item">
        <span class="legend-color" style="background: #4CAF50;"></span>
        <span>Taxa de Aprovação</span>
      </div>
      <div class="legend-item">
        <span class="legend-color" style="background: #F44336;"></span>
        <span>Taxa de Reprovação</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import axios from "../../../plugins/axios";
import Swal from 'sweetalert2';
const ls = require('local-storage')

export default {
  components: {
    loading: () => import("../../../components/loading.vue"),
    'bar-chart': {
      extends: Bar,
      props: ['chartData', 'options'],
      mounted() {
        this.renderChart(this.chartData, this.options)
      },
      watch: {
        chartData(newData) {
          this.renderChart(newData, this.options)
        }
      }
    }
  },
  data() {
    return {
      taxaAll: [],
      allData: [],
      anoLectivoAll: [],
      anoLectivoSelected: ls.get('anolectivo'),
      imsAssociado: [
        { id: 1, descricao: 'Todos', descricaoFilhacao: 'Todos' },
        { id: 2, descricao: 'IMS-Luanda', descricaoFilhacao: 'Afilhados IMS Maianga' },
        { id: 3, descricao: 'IMS-Kalawenda', descricaoFilhacao: 'Afilhados IMS Kalawenda' },
      ],
      imsAssociadoSelect: null,
      isLoading: false,
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: false,
            text: 'Taxa de Aprovação e Reprovação por Ano Letivo'
          },
          legend: {
            display: false,
            position: 'top'
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return `${context.dataset.label}: ${context.raw}%`
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            max: 100,
            ticks: {
              callback: function (value) {
                return value + '%'
              }
            }
          }
        }
      }
    }
  },

  async created() {
    await this.carregarAnosLectivos();
    await this.carregarDados()

    if (this.role == 'ROLE_GP') {
      this.imsAssociadoSelect = 'Todos'
    } else if (this.role == 'ROLE_DIR' && this.instituicao == 1) {
      this.imsAssociadoSelect = 'IMS-Luanda';
    } else if (this.role == 'ROLE_DIR' && this.instituicao == 144) {
      this.imsAssociadoSelect = 'IMS-Kalawenda';
    }
  },

  computed: {
    role() {
      return ls.get('role')
    },
    instituicao() {
      return ls.get('i_id')
    },

    imsFiltrados() {
      if (this.role == 'ROLE_GP' || this.role ==  'ROLE_ADM') {
        return this.imsAssociado
      } else if (this.role == 'ROLE_DIR' && this.instituicao == 1) {
        return this.imsAssociado.filter(item => item.descricao == 'IMS-Luanda');
      } else if (this.role == 'ROLE_DIR' && this.instituicao == 144) {
        return this.imsAssociado.filter(item => item.descricao == 'IMS-Kalawenda');
      } else if (this.role == 'ROLE_DIR' && this.instituicao != 144 && this.instituicao != 1) {
        return [];
      }
    }
  },

  methods: {
    async carregarAnosLectivos() {
      this.isLoading = true;
      try {
        this.anoLectivoAll = await axios.get(`/getAnosLectivosAll`).then((res) => res.data);
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async carregarDados() {
      this.isLoading = true
      try {
        let anolectivo;

        if (this.anoLectivoSelected) {
          anolectivo = this.anoLectivoSelected
        } else {
          anolectivo = ls.get('anolectivo')
        }

        const response = await axios.get(`/getTaxaAprovacaoReprovacao/${anolectivo}`)

        this.allData = response.data;
        this.taxaAll = this.allData;

        if (this.taxaAll.length > 0) {
          const anos = this.taxaAll.map(item => item.anoLectivo)
          const aprovados = this.taxaAll.map(item => item.taxa_aprovacao)
          const reprovados = this.taxaAll.map(item => item.taxa_reprovacao)

          this.chartData = {
            labels: anos,
            datasets: [
              {
                label: 'Taxa de Aprovação',
                backgroundColor: '#4CAF50',
                borderColor: '#388E3C',
                borderWidth: 1,
                data: aprovados
              },
              {
                label: 'Taxa de Reprovação',
                backgroundColor: '#F44336',
                borderColor: '#D32F2F',
                borderWidth: 1,
                data: reprovados
              }
            ]
          }
        } else {
          this.chartData = null
        }
      } catch (error) {
        console.error("Erro ao carregar dados:", error)
        this.chartData = null
      } finally {
        this.isLoading = false
      }
    },

    async filtrarIMS() {
      if (this.imsAssociadoSelect == 'Todos') {
        await this.carregarDados();
        return;
      } else {
        this.isLoading = true
        try {
          let response = await axios.get(`/getTaxaAprovacaoReprovacaoFiltred/${this.anoLectivoSelected}/${this.imsAssociadoSelect}`)
          this.allData = response.data;
          this.taxaAll = this.allData;

          if (this.taxaAll.length > 0) {
            const anos = this.taxaAll.map(item => item.anoLectivo)
            const aprovados = this.taxaAll.map(item => item.taxa_aprovacao)
            const reprovados = this.taxaAll.map(item => item.taxa_reprovacao)

            this.chartData = {
              labels: anos,
              datasets: [
                {
                  label: 'Taxa de Aprovação',
                  backgroundColor: '#4CAF50',
                  borderColor: '#388E3C',
                  borderWidth: 1,
                  data: aprovados
                },
                {
                  label: 'Taxa de Reprovação',
                  backgroundColor: '#F44336',
                  borderColor: '#D32F2F',
                  borderWidth: 1,
                  data: reprovados
                }
              ]
            }
          } else {
            this.chartData = null
          }
        } catch (error) {
          Swal.fire('Informação', 'Erro ao filtrar os dados', 'error')
        } finally {
            this.isLoading = false;
        }
      }
    },
  }
}
</script>

<style scoped>
.chart-card {
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  padding: 24px;
  margin: 0 auto;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  border: 1px solid #EAEDF0;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.chart-header h2 {
  margin: 0;
  color: #1F2937;
  font-size: 1.25rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-btn {
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #4F46E5;
}

.refresh-btn:hover {
  background: #F3F4F6;
  transform: rotate(90deg);
}

.refresh-btn:active {
  transform: rotate(180deg);
}

.controls {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 300px;
}

.chart-container {
  height: 400px;
  position: relative;
  margin-bottom: 16px;
  background: #F9FAFB;
  border-radius: 8px;
  padding: 16px;
}

.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #6B7280;
  font-size: 0.875rem;
}

.no-data svg {
  margin-bottom: 16px;
  opacity: 0.5;
}

.no-data p {
  margin: 0;
  font-size: 0.875rem;
}

.chart-footer {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 16px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  color: #4B5563;
}

.legend-color {
  width: 14px;
  height: 14px;
  border-radius: 3px;
}

@media (max-width: 768px) {
  .chart-card {
    padding: 16px;
  }

  .chart-header h2 {
    font-size: 1.1rem;
  }

  .chart-footer {
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }
}
</style>